import Check from "pages/_components/Check";
import GridTable from "pages/_components/GridTable/GridTable";
import I18n from "pages/_components/I18n";
import { bool, func, string } from "prop-types";
import React from "react";
import { getBoolOption } from "util/creditBills";

const CreditBillTitleColumns = ({ onCheckAll, areAllChecked, tabOption, isDesktop }) => {
    const { isEmitted, isInTenure, isToPay, isReceived } = getBoolOption(tabOption);

    return (
        <>
            <GridTable.Data className={isDesktop && "checkbox-title"}>
                <Check
                    hideLabel
                    name="selectAll"
                    id="selectAll"
                    onChange={(e) => onCheckAll(e.target.checked)}
                    checked={areAllChecked()}
                />
            </GridTable.Data>
            {isEmitted && (
                <>
                    <GridTable.Data alignX="center">
                        <I18n component="span" id="creditBill.table.debtor" />
                    </GridTable.Data>
                    <GridTable.Data alignX="center">
                        <I18n component="span" id="creditBill.table.holder" />
                    </GridTable.Data>
                </>
            )}
            {isReceived && (
                <>
                    <GridTable.Data alignX="center">
                        <I18n component="span" id="creditBill.table.emitter" />
                    </GridTable.Data>
                    <GridTable.Data alignX="center">
                        <I18n component="span" id="creditBill.table.holder" />
                    </GridTable.Data>
                </>
            )}
            {isToPay && (
                <>
                    <GridTable.Data alignX="center">
                        <I18n component="span" id="creditBill.table.holder" />
                    </GridTable.Data>
                    <GridTable.Data alignX="center">
                        <I18n component="span" id="creditBill.table.emitter" />
                    </GridTable.Data>
                </>
            )}

            {isInTenure && (
                <>
                    <GridTable.Data alignX="center">
                        <I18n component="span" id="creditBill.table.emitter" />
                    </GridTable.Data>
                    <GridTable.Data alignX="center">
                        <I18n component="span" id="creditBill.table.debtor" />
                    </GridTable.Data>
                </>
            )}

            <GridTable.Data columnStart={4} alignX="center">
                <I18n component="span" id="creditBill.table.emission" />
            </GridTable.Data>
            <GridTable.Data columnStart={5} alignX="center" className={isDesktop && "spacing-class-title"}>
                <I18n component="span" id="creditBill.table.expiration" />
            </GridTable.Data>
            <GridTable.Data columnStart={6} alignX="center">
                <I18n component="span" id="creditBill.table.amount" />
            </GridTable.Data>
            <GridTable.Data columnStart={7} alignX="center" className={isDesktop && "margin-class-title"}>
                <I18n component="span" id="creditBill.table.state" />
            </GridTable.Data>
            <GridTable.Data columnStart={8} alignX="center">
                <I18n component="span" id="creditBill.table.registeredCbu" />
            </GridTable.Data>
            <GridTable.Data columnStart={9} alignX="center" className={isDesktop && "action-class-title"} />
        </>
    );
};

CreditBillTitleColumns.propTypes = {
    onCheckAll: func.isRequired,
    areAllChecked: bool.isRequired,
    tabOption: string.isRequired,
    isDesktop: bool.isRequired,
};

export default CreditBillTitleColumns;
